export default __webpack_public_path__ + "static/media/get_into_teams.6fc9939b.mp3";